import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export const metaQuery = graphql(`
  query Meta {
    meta {
      is_verified
      overdue_invoice_count
      pending_task_count
      pending_change_request_count
      pending_payment_request_count
      default_rates {
        id
        currency
        booking_fee_amount
        charge_per_move_amount
        holding_deposit_amount
        hire_unit_rate
        extra_hire_unit_deposit_rate
      }
      feature_flags {
        type
        enabled
      }
      primary_billing_entity {
        id
        name
      }
    }
  }
`);

export type DefaultRateRecord = ResultOf<
  typeof metaQuery
>["meta"]["default_rates"][number];
